(function() { window.GUID_71363c62_b755_495d_a5c4_6fca0fe2378d = { getGuid: function() { return "71363c62-b755-495d-a5c4-6fca0fe2378d"; } }; })();
var CompuSport;
(function (CompuSport) {
    var timeOutId = null;
    function Lag(lagTime, callback) {
        if (timeOutId != null) {
            clearTimeout(timeOutId);
        }
        timeOutId = setTimeout(callback, lagTime);
        return timeOutId;
    }
    CompuSport.Lag = Lag;
    function LagLocal(localTimeOutId, lagTime, callback) {
        if (localTimeOutId != null) {
            clearTimeout(localTimeOutId);
        }
        localTimeOutId = window.setTimeout(callback, lagTime);
        return localTimeOutId;
    }
    CompuSport.LagLocal = LagLocal;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Lag.js.map
